module.exports = __webpack_public_path__ + "static/media/submenu-test.bc0e01cd.jpg";